import { createSelector } from 'reselect';

const getChannels = (store) => store.channels;

const selectChannelsInputs = [getChannels];
const selectChannelsFunc = (channels) => (channels ? channels : []);

export const selectChannels = createSelector(
  selectChannelsInputs,
  selectChannelsFunc
);

const getNoteChannel = (store) =>
  store.channels.find((chan) => chan.type === 'internal_note');

const selectNoteChannelInputs = [getNoteChannel];
const selectNoteChannelFunc = (channel) => (channel ? channel : {});

export const selectNoteChannel = createSelector(
  selectNoteChannelInputs,
  selectNoteChannelFunc
);

const getGeckoChannel = (store) =>
  store.channels.find((chan) => chan.type === 'gecko_chat');

const selectGeckoChannelInputs = [getGeckoChannel];
const selectGeckoChannelFunc = (channel) => (channel ? channel : {});

export const selectGeckoChannel = createSelector(
  selectGeckoChannelInputs,
  selectGeckoChannelFunc
);
